import { render, staticRenderFns } from "./JobOverlay.vue?vue&type=template&id=2d5153b8&scoped=true&"
import script from "./JobOverlay.vue?vue&type=script&lang=js&"
export * from "./JobOverlay.vue?vue&type=script&lang=js&"
import style0 from "./JobOverlay.vue?vue&type=style&index=0&id=2d5153b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5153b8",
  null
  
)

export default component.exports